import { mainApi } from "services/main";

interface GenerateChatUrlInput {
  agentName: string;
  protocolType: "WEBSOCKET";
  teamName: string;
  sessionId?: string;
}

interface GenerateChatUrlOutput {
  url: string;
  sessionId: string;
  expiresAt: string;
}

export interface AgentSessionSummary {
  sessionId: string;
  updatedAt: number;
  title?: string;
}

interface ListSessionsInput {
  agentName: string;
  teamName: string;
  limit?: number;
  nextToken?: string | null;
}

interface ListSessionsOutput {
  sessions: AgentSessionSummary[];
  nextToken: string | null;
}

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    generateChatUrl: builder.mutation<
      GenerateChatUrlOutput,
      GenerateChatUrlInput
    >({
      query: (body) => ({
        url: "agent/chat-url",
        method: "POST",
        body,
      }),
    }),
    listSessions: builder.query<ListSessionsOutput, ListSessionsInput>({
      query: (body) => ({
        url: "agent/sessions",
        method: "POST",
        body,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGenerateChatUrlMutation, useLazyListSessionsQuery } =
  extendedApi;
